<template>
    <div class="data-item" v-if="data != null">
        <div class="lineContainer">
            <div class="line1"></div>
            <div class="line2"></div>
            <div class="line3"></div>
            <div class="line4"></div>
        </div>
        <div class="itemContainer">
            <template v-for="index in 2">
                <div class="item" :key="index">
                    <div>
                        <span class="value">{{
                            toThousands(data[index - 1].value)
                        }}</span>
                        <!-- <span class="value">
                            <countTo
                                :startVal="startVal"
                                :endVal="endVal"
                                :duration="1000"
                                :decimals="decimals()"
                            ></countTo>
                        </span> -->
                        <span class="unit">
                            {{
                                data[index - 1].unit ? data[index - 1].unit : ""
                            }}
                        </span>
                    </div>
                    <span class="key">
                        {{ data[index - 1].key ? data[index - 1].key : "-" }}
                    </span>
                </div>
            </template>
        </div>
    </div>
</template>


<script>
import countTo from "vue-count-to";
export default {
    components: { countTo },
    name: "DataItem",
    props: {
        data: Array,
    },
    data() {
        // console.log(this.data);
        return {
            // startVal: 0,
            // endVal: data[0].value,
        };
    },
    // watch: {
    //     data: function (n, o) {
    //         // console.log("watch", parseInt(n), parseInt(o));
    //         this.startVal = o;
    //         this.endVal = n;
    //     },
    // },

    methods: {
        toThousands(num) {
            return (num || 0).toString().replace(/(\d)(?=(?:\d{3})+$)/g, '$1,');
        },
        decimals() {
            if (this.endVal < 1) {
                return 3;
            } else if (this.endVal < 500) {
                return 2;
            } else {
                return 0;
            }
        },
    },
};
</script>

<style scoped lang="less">

.data-item {
    width: 33.33%;
    height: 100%;
    color: #e6f3fd;
    display: flex;
    flex-direction: row;

    .lineContainer {
        margin-left: 160/192vw;
    }
    .line1 {
        .w(2);
        .h(36);
        background: #0d94ff;
        opacity: 0.3;
    }
    .line2 {
        .w(2);
        .h(6);
        background: #0d94ff;
        opacity: 0.7;
        margin-top: 30/108vh;
    }
    .line3 {
        .w(2);
        .h(6);
        background: #0d94ff;
        opacity: 0.7;
        margin-top: 300/108vh;
    }
    .line4 {
        .w(2);
        .h(36);
        background: #0d94ff;
        opacity: 0.3;
        margin-top: 30/108vh;
    }
    .itemContainer {
        margin-left: 100/192vw;
        margin-top: 50/108vh;
    }
    .item {
        height: 50%;
        justify-content: flex-start;
        align-items: flex-start;
        flex-wrap: nowrap;

        span:first-child {
            .font(18);
        }

        span:last-child {
            .font(14);
        }
    }
}
</style>